// extracted by mini-css-extract-plugin
export default {"root":"Container_root__Ez2OO","row":"Container_row__5YlAD","column":"Container_column__Q9hdZ"};